const DEEP_LINK_TARGET_KEY = 'deepLinkTarget';
const ALLOWED_PREFIXES = ['/document'];

const isAllowedTarget = (target) =>
  typeof target === 'string' && ALLOWED_PREFIXES.some((prefix) => target.startsWith(prefix));

export const saveDeepLinkTarget = (location) => {
  if (!location) return;
  const target = `${location.pathname}${location.search || ''}`;
  if (isAllowedTarget(target)) {
    sessionStorage.setItem(DEEP_LINK_TARGET_KEY, target);
  }
};

export const captureDeepLinkTarget = () => {
  if (typeof window === 'undefined') return;
  saveDeepLinkTarget(window.location);
};

export const consumeDeepLinkTarget = () => {
  const target = sessionStorage.getItem(DEEP_LINK_TARGET_KEY);
  sessionStorage.removeItem(DEEP_LINK_TARGET_KEY);
  return isAllowedTarget(target) ? target : null;
};
